export default "__VITE_ASSET__BbeSbg6b__"